// Shared helpers for feature flag checks.
const isFeatureEnabled = (user, key, defaultValue = true) => {
  if (typeof user?.[key] === 'undefined') {
    return defaultValue;
  }

  return !!user[key];
};

export const isOnboardingEnabled = (user) => {
  return isFeatureEnabled(user, 'onboarding_enabled');
};

export const isInspectionsEnabled = (user) =>
  isFeatureEnabled(user, 'inspections_enabled', false);
export const isComplaintsEnabled = (user) =>
  isFeatureEnabled(user, 'complaints_enabled', false);
export const isNovEnabled = (user) =>
  isFeatureEnabled(user, 'nov_enabled', false);
export const isPenaltiesEnabled = (user) =>
  isFeatureEnabled(user, 'penalties_enabled', false);
export const isSchedulingEnabled = (user) =>
  isFeatureEnabled(user, 'scheduling_enabled', false);
export const isContactLogEnabled = (user) =>
  isFeatureEnabled(user, 'contact_log_enabled', false);
export const isDonationsEnabled = (user) =>
  isFeatureEnabled(user, 'donations_enabled');
/** @deprecated Prefer useAuth().hasHomeDelivery / canUseDistributions */
export const isDistributionsEnabled = (user) =>
  isFeatureEnabled(user, 'distributions_enabled', false);
